<!-- sort section -->
<div
	class="relative inline w-auto sm:flex sm:justify-end sm:items-stretch"
	ucDropdown
	elementId="sort"
	[ngClass]="{ 'lg:hidden': showSelectOnDesktop }"
>
	<button
		[ngClass]="buttonWidth"
		class="inline-flex items-center justify-center p-3 text-gray-500 border rounded-full cursor-pointer focus:outline-none lg:flex lg:rounded-lg lg:border-0"
	>
		<!-- multiple arrows - mobile -->
		<uc-sort-arrows-svg class="inline-block mr-1 lg:hidden" />
		<span
			class="text-sm font-bold text-gray-900 pointer-events-none lg:text-gray-500 lg:font-normal"
			>Sort by</span
		>
		<!-- down arrow: desktop -->
		<uc-arrow-down-svg class="hidden h-5 pl-2 lg:inline-block" />
	</button>
	<div
		class="absolute min-w-full bg-white border border-gray-200 rounded-lg shadow-lg dropdown-content sm:right-0 sm:left-auto top-12 sm:w-72"
		[ngClass]="customStyles"
	>
		<ul class="py-2 text-sm text-gray-700 sm:pr-4">
			@for (option of sortOptions; track option) {
				<li class="px-3 py-2 sm:px-4">
					<button
						(click)="onSortOption(option)"
						class="flex items-center w-full gap-1 text-left sm:gap-4 only-tab-focus whitespace-nowrap"
					>
						<span>{{ option.text }}</span>
						@if (option.id === optionSelected.id) {
							<uc-tick-svg />
						}
					</button>
				</li>
			}
		</ul>
	</div>
</div>

<!-- select option on desktop-->
<select
	name="select-sort"
	id="select-sort"
	class="hidden py-3 pl-4 pr-12 text-gray-500 border border-gray-300 rounded-md"
	[ngClass]="{ 'lg:block': showSelectOnDesktop }"
	[(ngModel)]="optionSelected"
	(change)="onSortOption(optionSelected)"
>
	@for (option of sortOptions; track option) {
		<option [ngValue]="option">
			{{ option.text }}
		</option>
	}
</select>
